import { BottomSummaryBarV2, SummaryColumn } from '@/components/custom/erp';

interface BottomBarProps {
  tongTien: number;
  tongThue: number;
  tongThanhToan: number;
}

export function BottomBar({ tongTien, tongThue, tongThanhToan }: BottomBarProps) {
  const columns: SummaryColumn[] = [
    {
      className: 'min-w-[240px]',
      fields: [
        { name: 't_tien_nt', label: 'Tổng tiền', value: tongTien, inputClassName: 'text-right' },
        { name: 't_thue_nt', label: 'Tổng thuế', value: tongThue, inputClassName: 'text-right' }
      ]
    },
    {
      className: 'min-w-[260px]',
      fields: [{ name: 't_tt_nt', label: 'Tổng thanh toán', value: tongThanhToan, inputClassName: 'text-right' }]
    }
  ];

  return <BottomSummaryBarV2 columns={columns} />;
}
